import { useCallback, useState } from 'react'

/**
 * Modal state with generic data
 * Useful for modals that need to pass data to the modal
 * Does not clear the data when the modal is closed so there is content change
 */
function useModalDataState<T>(initial: { data: T; isOpen?: boolean }) {
  const [isOpen, setIsOpen] = useState(initial?.isOpen ?? false)
  const [data, setData] = useState<T>(initial.data)

  const open = useCallback((data: T) => {
    setIsOpen(true)
    setData(data)
  }, [])

  const close = useCallback(() => {
    setIsOpen(false)
  }, [])

  return {
    isOpen,
    data,
    open,
    close,
  }
}

/**
 * Modal state without data
 */
export function useModalState(initial?: boolean) {
  const [isOpen, setIsOpen] = useState(initial ?? false)

  const open = useCallback(() => {
    setIsOpen(true)
  }, [])

  const close = useCallback(() => {
    setIsOpen(false)
  }, [])

  return {
    isOpen,
    open,
    close,
  }
}

export default useModalDataState
